import React from "react";
import {
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "@material-ui/core";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RefreshIcon from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import {styled} from "@mui/material/styles";
import { ActionTypes } from "../../state/constantes/ActionTypes";
import * as deleteActions from "../../state/actions/ShimpentDeleteAction";
import * as refreshActions from "../../state/actions/ShipmentRefreshAction";
import {connect, useSelector} from "react-redux";
import AlertDialog from "../../../../common/components/Dialog";
import NtnEquipementStatesTimeLineExport from "./NtnEquipementStatesTimeLineExport";
import NtnEquipementStatesTimeLineImport from "./NtnEquipementStatesTimeLineImport";
import {PuiGrid, PuiSection, PuiTextField} from "@portnet/ui"

const StyledTableRow = styled(TableRow)(({theme}) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));



function NtnRow(props) {
    const portList = useSelector(state => state.PortsReducer) ?? [];
    const {row} = props;
    const [open, setOpen] = React.useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
    const [showRefreshDialog, setShowRefreshDialog] = React.useState(false);

    function handleCancel() {
        setShowDeleteDialog(false);
        setShowRefreshDialog(false);
    }

    function handleConfirmDelete(id) {
        props.handleDeleteItem({
            type: ActionTypes.ACTION_SHIPMENT_DELETE_START,
            payload: id,
            data: props.shipmentByUser.data,
        });
        setShowDeleteDialog(false);
    }

    function getLibellePort(port) {
      let i = portList.data.findIndex(value => port == value.code);
      return portList.data[i]?.label ;
    }

    function handleConfirmRefresh(id) {
        props.handleRefreshItem({
            type: ActionTypes.ACTION_SHIPMENT_REFRESH_START,
            payload: id,
            data: props.shipmentByUser.data,
        });
        setShowRefreshDialog(false);
    }

    return (
        <React.Fragment>
            <TableRow sx={{"& > *": {borderBottom: "unset"}}}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>
                <TableCell>{row.idEquipment}</TableCell>
                <TableCell>{getLibellePort(row.port)}</TableCell>
                <TableCell>{row.customsStatus}</TableCell>
                <TableCell>
                    {row?.portcall?.list[0]?.eTA?.substring(0, 16)} -{" "}
                    {row?.portcall?.list[0]?.eTD?.substring(0, 16)}
                </TableCell>
                <TableCell>{row.dateMaj?.substring(0, 16)}</TableCell>
                <TableCell>
                    <DeleteForeverIcon
                        style={{
                            cursor: "pointer",
                            color: "#232f66",
                            marginLeft: "30%",
                        }}
                        id={row.id}
                        onClick={() => setShowDeleteDialog(true)}
                    ></DeleteForeverIcon>
                    <AlertDialog
                        show={showDeleteDialog}
                        title={"Supprimer"}
                        description={"Voulez vous supprimer ce conteneur ?"}
                        confirm={() => handleConfirmDelete(row.id)}
                        cancel={() => handleCancel()}
                    ></AlertDialog>
                    {row.id &&
          <RefreshIcon
            style={{ cursor: "pointer", color: "#232f66" }}
            id={row.id}
            onClick={() => setShowRefreshDialog(true)}
          ></RefreshIcon>
                    }
          <AlertDialog
            show={showRefreshDialog}
            title={"Raffrichir"}
            description={
              "Cette operation vous coutera des frais, Voulez vous raffrichier les informations de ce conteneur ?"
            }
            confirm={() => handleConfirmRefresh(row.id)}
            cancel={() => handleCancel()}
          ></AlertDialog>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            {row.bookingNumber == null || row.bookingNumber == "" ? (
                                <NtnEquipementStatesTimeLineImport
                                    data={{row}}
                                ></NtnEquipementStatesTimeLineImport>
                            ) : (
                                <NtnEquipementStatesTimeLineExport
                                    data={{row}}
                                ></NtnEquipementStatesTimeLineExport>
                            )}

                            <PuiSection title="Informations conteneur">
                                <PuiGrid container spacing={1}>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Port"
                                            value={getLibellePort(row.port)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="N° Conteneur"
                                            value={row.idEquipment}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Nom du terminal"
                                            value={row.terminalOperatorName}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="N° voyage "
                                            value={row.idPortCall}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Entrant/Sortant "
                                            value={row.inbound == "O" ? "Sortant" : "Entrant"}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Transporteur "
                                            value={row.carrier}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Type équipement  "
                                            value={row.typeOfEquipment}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="N° Connaissement  "
                                            value={row.blNumber != null ? row.blNumber : row.blnumber}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="N° Booking "
                                            value={row.bookingNumber}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Poids Brut "
                                            value={row.grossWeight + ' Tn'}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Poids Net "
                                            value={row.netWeight != null ? row.netWeight + " Tn" : ""}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Marchandises dangereuses "
                                            value={row.dangerousGoods === true ? "Oui" : "Non"}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Transbordement "
                                            value={row.transhipment === true ? "Oui" : "Non"}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Statut douanier "
                                            value={row.transhipment === true ? "Oui" : "Non"}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Date main levée "
                                            value={row.customsClearanceDateTime?.substring(0, 16)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Date entrée au terminal "
                                            value={row.gateInDateTime?.substring(0, 16)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Date sortie du terminal "
                                            value={row.gateOutDateTime?.substring(0, 16)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Date chargement "
                                            value={row.loadedDateTime?.substring(0, 16)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Date déchargement "
                                            value={row.dischargedDateTime?.substring(0, 16)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={3} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Date livraison vide "
                                            value={row.emptyDeliveredDateTime?.substring(0, 16)}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={6} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Type de transport d'entrée "
                                            value={row.inboundMeansOfTransportType}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={6} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label=" Nom du transport d'entrée "
                                            value={row.inboundMeansOfTransportName}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={6} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Type de transport de sortie "
                                            value={row.outboundMeansOfTransportType}
                                        />
                                    </PuiGrid>
                                    <PuiGrid item sm={6} xs={6}>
                                        <PuiTextField
                                            formik={false}
                                            consultation
                                            label="Nom du transport de sortie "
                                            value={row.outboundMeansOfTransportName}
                                        />
                                    </PuiGrid>
                                </PuiGrid>
                            </PuiSection>


                            {row.portcall && (
                                <>
                                    <PuiSection title="Informations navire">
                                        <PuiGrid container spacing={1}>
                                            {row.portcall?.list?.map((record) => (
                                                <>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="Port"
                                                            value={record.port}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="IMO du navire "
                                                            value={record.iMOVessel}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="Nom du navire "
                                                            value= {record.vesselName}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="N° voyage "
                                                            value= {record.idPortCall}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="ETA "
                                                            value=  {record.eTA?.substring(0, 16)}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="ATA "
                                                            value=  {record.aTA?.substring(0, 16)}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="ETD "
                                                            value=  {record.eTD?.substring(0, 16)}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="ATD "
                                                            value=  {record.aTD?.substring(0, 16)}
                                                        />
                                                    </PuiGrid>
                                                    <PuiGrid item sm={3} xs={6}>
                                                        <PuiTextField
                                                            formik={false}
                                                            consultation
                                                            label="callSign "
                                                            value=  {record.callSign}
                                                        />
                                                    </PuiGrid>
                                                </>
                                            ))}
                                        </PuiGrid>
                                    </PuiSection>
                                </>
                            )}
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleDeleteItem: (action) => {
            dispatch(deleteActions.shipmentDeleteStart(action));
        },
        handleRefreshItem: (action) => {
            dispatch(refreshActions.shipmentRefreshStart(action));
        },
    };
};

const mapStateToProps = (state) => {
    return {
        shipmentByUser: state.ShipmentByUserReducer,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NtnRow);
